import {AutoComplete} from "../openings/AutoComplete";
import {css} from "@emotion/css";
import {grey} from "@mui/material/colors";
import {TID} from "../../../../misc/scroller/Table";

export function NativeAutoComplete<T extends TID>(props: {
    placeholder: string;
    onAssign(input: T): void;
    onCreate(name: string): void;
    makeLabel(v: T): string;
    onSearch(search: string): Promise<T[]>;
}) {

    return (
        <AutoComplete<T>
            useNativeInput={true}
            placeholder={props.placeholder}
            search={props.onSearch}
            className={groupNumberClass}
            value={null}
            equals={(a, b) => a.id === b.id}
            makeLabel={props.makeLabel}
            onSelect={props.onAssign}
            onCreate={props.onCreate} />
    )
}

const groupNumberClass = css({
    "&::placeholder": {
        fontStyle: "italic",
        color: grey["500"]
    }
})